import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface ApprovePrefundReturnPayload {
  invoice_id: string;
  invoice_amount: number;
}

export const useApproveEoyReconReturnQuery = () => {
  const { mutateAsync, isLoading } = useMutation(
    (value: ApprovePrefundReturnPayload) =>
      api.post(API_URL.EOY_PLAN_RECONCILIATIONS_APPROVE, value),
  );

  const handleSave = useCallback(
    async (value: ApprovePrefundReturnPayload) => {
      await mutateAsync(value);
    },
    [mutateAsync]
  );

  return {
    isLoading,
    handleSave,
  };
};
